import React from "react";
import styles from "./ImageContentSection.module.css";

function ImageContentSection({ title, content, image, reverse = false }) {
  const hasImage = Boolean(image);

  return (
    <div
      className={`w-100 ${
        reverse ? styles.whiteBackground : styles.grayBackground
      }`}
    >
      <div className={`container-fluid py-5 ${styles.sectionWrapper}`}>
        <div
          className={`row d-flex align-items-center ${
            reverse ? "flex-row-reverse" : ""
          }`}
        >
          {/* ==== Image Section ==== */}
          {hasImage && (
            <div className="col-12 col-md-4">
              <img
                src={image}
                alt={title || "content image"}
                className={styles.image}
              />
            </div>
          )}

          {/* ==== Text Section ==== */}
          <div className={hasImage ? "col-12 col-md-8" : "col-12"}>
            <div className={styles.contentBox}>
              {title && <h5 className={`main_subheading ${styles.title}`}>{title}</h5>}

              <div className={styles.content}>
                {Array.isArray(content) ? (
                  content.map((para, index) => <p key={index}>{para}</p>)
                ) : (
                  <p className="main_paragraph">{content}</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ImageContentSection;
